<template>
  <div :class="classes">
    <div class="message-popup__content">
      <slot name="content"></slot>
    </div>
    <div v-if="!!$slots.actions" class="message-popup__actions">
      <slot name="actions"></slot>
    </div>
    <a v-if="!inline" @click="close()" class="message-popup__close">
      <IconTimes />
    </a>
  </div>
</template>

<script>
  import IconTimes from './icons/Times.vue'

  export default {
    components: {
      IconTimes,
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      extraClasses: {
        type: Array,
        default: () => [],
      },
      inline: {
        type: Boolean,
        default: false,
      },
      unobtrusive: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        closedByUser: false,
      }
    },
    computed: {
      showPopup() {
        return this.inline || (!this.closedByUser && this.visible)
      },
      classes() {
        let classes = [...this.extraClasses, 'message-popup']
        if (this.inline) {
          classes.push('message-popup--inline')
        }
        if (this.showPopup) {
          classes.push('message-popup--visible')
        }
        if (this.unobtrusive) {
          classes.push('message-popup--unobtrusive')
        }
        return classes.join(' ')
      },
    },
    methods: {
      close() {
        this.closedByUser = true
      },
    },
  }
</script>

<style lang="scss">
  .message-popup {
    position: fixed;
    bottom: 0;
    transition: $transition-base;
    left: 50%;
    right: 50%;
    max-width: 28rem;
    width: 85%;
    z-index: 10;
    transform: translate(-50%, 100%);
    box-shadow: 2px 2px 9px rgba(0, 0, 0, 0.2);
    padding: spacer(1) spacer(3) spacer(1) spacer(2);
    border-left: 4px solid $community;
    background: $white;

    @media (min-width: $bp-sm) {
      padding: spacer(2) spacer(4) spacer(2) spacer(3);
    }

    &--delete {
      border-left-color: $error-color;

      .button--primary {
        background: $error-color;
        color: $white;

        &:hover,
        &:focus,
        &:active {
          color: $white;
          background: darken($error-color, 5%);
        }
      }
    }

    &--visible {
      transform: translate(-50%, -50%);
      bottom: spacer(3);

      @media (min-width: $bp-ssm) {
        bottom: spacer(4);
      }
    }

    &--inline {
      margin: spacer(2) auto;
      width: auto;
      position: static;
      transform: initial;
    }

    &--unobtrusive {
      box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);

      @media (min-width: $bp-sm) {
        padding: spacer(2) spacer(2);
      }

      .message-popup__content {
        font-weight: $font-weight-base;
        line-height: $line-height-sm;
      }
    }

    &__content {
      font-weight: bold;

      @media (min-width: $bp-sm) {
        font-size: $font-size-md;
      }
    }

    &__actions {
      margin-top: spacer(1);
      display: flex;
      justify-content: center;

      button,
      a {
        margin: 0 spacer(1);
      }
    }

    button,
    a {
      &.primary {
      }
    }

    &__close {
      position: absolute;
      top: spacer(0.5);
      right: spacer(1);
      width: 0.75em;
      cursor: pointer;
      transition: $transition-base;

      .icon {
        vertical-align: middle;
      }
    }
  }
</style>
